import { DropDownInput } from '../_input/_dropdown';

export default function DeliveryInfo({
    cities,
    brancheCities,
    filterBranches,
    selectcity,
    selectBranch,
    CarShippingInfo,
    handelfilterBranches,
    deliveryTimeAccounting,
    trans,
}) {
    return (
        <div className="carOverview-page-body-delevary" style={{ marginTop: '2rem' }}>
            {/* Features/Trust badges row */}
            <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '12px',
                    marginBottom: '2rem'
                }}
            >
                {[
                    { icon: "/assets/icons/part/shipping.svg", label: trans('new:locations-Send') },
                    { icon: "/assets/icons/part/safePayment.svg", label: trans('new:safe_pay') },
                    { icon: "/assets/icons/part/reliability.svg", label: trans('new:trust_product') }
                ].map((item, idx) => (
                    <div
                        key={idx}
                        className="hj-premium-card"
                        style={{
                            flex: '1 1 120px',
                            padding: '12px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            textAlign: 'center',
                            gap: '8px',
                            borderRadius: '16px',
                            background: 'var(--co-surface)',
                            boxShadow: 'var(--co-shadow-sm)'
                        }}
                    >
                        <img alt="" src={item.icon} style={{ width: '28px', height: '28px', opacity: 1 }} />
                        <span style={{ fontSize: '12px', fontWeight: 800, color: 'var(--co-t1)' }}>{item.label}</span>
                    </div>
                ))}
            </div>

            {/* Delivery/Receipt options */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                {cities && cities?.length > 0 && (
                    <div className="hj-premium-card" style={{ padding: '24px', borderRadius: '16px', border: '1px solid rgba(0,0,0,0.06)', background: 'var(--co-surface)' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--co-green)' }}>
                                <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                    <rect x="1" y="3" width="15" height="13" />
                                    <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
                                    <circle cx="5.5" cy="18.5" r="2.5" />
                                    <circle cx="18.5" cy="18.5" r="2.5" />
                                </svg>
                            </div>
                            <h3 style={{ fontSize: '18px', fontWeight: 800, color: 'var(--co-t1)', margin: 0 }}>
                                {cities?.length > 1 ? trans('new:expected_delivery_date') : trans('new:delivery')}
                            </h3>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '16px', padding: '16px', borderRadius: '12px', background: 'var(--co-bg2)', border: '1px solid rgba(0,0,0,0.03)' }}>
                            {cities?.length > 1 ? (
                                <div style={{ minWidth: '240px', flex: 1 }}>
                                    <DropDownInput
                                        inputName="delevaryCitie"
                                        defaultOption={{ text: trans('new:city'), value: '0' }}
                                        options={[...cities]}
                                        onSelect={CarShippingInfo}
                                        selectedValue={selectcity}
                                        className="hj-dropdown-minimal"
                                    />
                                </div>
                            ) : (
                                <div style={{ fontSize: '16px', fontWeight: 900, color: 'var(--co-green)', flex: 1 }}>{cities[0]?.text}</div>
                            )}

                            {deliveryTimeAccounting() && (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', background: 'rgba(24,169,78,0.08)', padding: '10px 16px', borderRadius: '10px' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <span style={{ fontSize: '12px', fontWeight: 700, color: 'var(--co-green)', opacity: 0.8 }}>{trans('new:expected_delivery_date')}</span>
                                        <span style={{ fontSize: '16px', fontWeight: 900, color: 'var(--co-green)' }}>{deliveryTimeAccounting()}</span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {brancheCities && brancheCities?.length > 0 && (
                    <div className="hj-premium-card" style={{ padding: '24px', borderRadius: '16px', border: '1px solid rgba(0,0,0,0.06)', background: 'var(--co-surface)' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--co-t3)' }}>
                                <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                                    <circle cx="12" cy="10" r="3" />
                                </svg>
                            </div>
                            <h3 style={{ fontSize: '18px', fontWeight: 800, color: 'var(--co-t1)', margin: 0 }}>{trans('new:receipt_from')}</h3>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            {brancheCities?.length > 1 ? (
                                <div style={{ width: '100%' }}>
                                    <DropDownInput
                                        inputName="brancheCitie"
                                        defaultOption={{ text: trans('new:city'), value: '0' }}
                                        options={[...brancheCities]}
                                        onSelect={handelfilterBranches}
                                        selectedValue={selectBranch}
                                    />
                                </div>
                            ) : (
                                <div style={{ fontSize: '16px', fontWeight: 800, color: 'var(--co-t1)', padding: '0 10px' }}>{filterBranches[0] && filterBranches[0][`${trans('model:description2')}`]}</div>
                            )}

                            {filterBranches.slice(0, 1)?.map((Branche, index) => (
                                <div
                                    key={index}
                                    style={{
                                        padding: '18px',
                                        borderRadius: '12px',
                                        background: 'var(--co-bg2)',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '14px',
                                        border: '1px solid rgba(0,0,0,0.03)'
                                    }}
                                >
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                        <div style={{ flex: 1 }}>
                                            <div style={{ fontSize: '13px', fontWeight: 600, color: 'var(--co-t3)', marginBottom: '4px' }}>{trans('new:branch')}</div>
                                            <div style={{ fontSize: '16px', fontWeight: 800, color: 'var(--co-t1)' }}>{Branche[`${trans('model:description2')}`]}</div>
                                        </div>
                                        <div style={{
                                            padding: '6px 12px',
                                            borderRadius: '8px',
                                            background: Branche.Enable ? 'rgba(24,169,78,.1)' : 'rgba(0,0,0,.05)',
                                            color: Branche.Enable ? 'var(--co-green)' : 'var(--co-t3)',
                                            fontSize: '12px',
                                            fontWeight: 800
                                        }}>
                                            {Branche.Enable ? trans('new:avilable1') : trans('new:not_avilable1')}
                                        </div>
                                    </div>

                                    {Branche.WorkingHoursFormat && (
                                        <div>
                                            <div style={{ fontSize: '12px', fontWeight: 600, color: 'var(--co-t3)', marginBottom: '4px' }}>{trans('new:work_days')}</div>
                                            <div style={{ fontSize: '14px', fontWeight: 600, color: 'var(--co-t2)' }}>{Branche.WorkingHoursFormat}</div>
                                        </div>
                                    )}

                                    <a
                                        target="_blank"
                                        rel="noreferrer"
                                        href={`https://www.google.com/maps/?q=${Branche.Latitude},${Branche.Longitude}`}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            marginTop: '4px',
                                            width: 'fit-content',
                                            color: 'var(--co-green)',
                                            fontSize: '14px',
                                            fontWeight: 800,
                                            textDecoration: 'none'
                                        }}
                                    >
                                        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.5">
                                            <polygon points="3 11 22 2 13 21 11 13 3 11" />
                                        </svg>
                                        <span style={{ borderBottom: '1.5px solid currentColor' }}>{trans('new:map')}</span>
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
